import React from 'react'
import { RichText as PrismicRichText } from 'prismic-reactjs'
import { Link } from 'react-router-dom'
import { ProductGridSlice } from 'modules/prismic'
import { FeaturedProductsSection } from 'app/sofia/components/FeaturedProductsSection'

export const ProductGrid = ({ primary, items }: ProductGridSlice) => {
  const { heading, sub_heading: subHeading, cta_label: ctaLabel, cta_url: ctaUrl } = primary

  return (
    <FeaturedProductsSection
      title={
        <>{PrismicRichText.render(heading)}</>
      }
      subTitle={
        <>{PrismicRichText.render(subHeading)}</>
      }
      cta={
        <>
          {ctaLabel && ctaUrl && (
            <Link to={ctaUrl}>{ctaLabel}</Link>
          )}
        </>
      }
      items={items}
    />
  )
}
